import React from "react";
import { Chip, Divider, MenuItem, Stack, Typography } from "@mui/material";
import { GlassPanel, ModernTextField } from "../styledComponents";

const DATE_FIELD_WIDTH = { xs: "100%", md: "50%" };
const VALUE_FIELD_WIDTH = { xs: "66.6667%", md: "41.6667%" };
const UNIT_FIELD_WIDTH = { xs: "33.3333%", md: "25%" };

const CHEMISTRY_FIELDS = [
  { label: "Glucosa", name: "glucosa", units: ["mg/dL"] },
  { label: "Creatinina", name: "creatinina", units: ["mg/dL", "µmol/L"] },
  { label: "Albúmina", name: "albumina", units: ["g/dL", "g/L"] },
  { label: "Urea", name: "urea", units: ["mg/dL", "mmol/L"] },
  { label: "Ácido úrico", name: "acidoUrico", units: ["mg/dL"] },
  { label: "Hierro", name: "hierro", units: ["μg/dL", "µmol/L"] },
  {
    label: "Glucosa en plasma",
    name: "glucosaPlasma",
    units: ["mg/dL", "mmol/L"],
  },
];

const QuimicaSanguinea = ({ formValues, onChange }) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onChange(name, value);
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <GlassPanel>
      <Stack spacing={3}>
        <Stack spacing={1}>
          <Typography variant="overline" sx={{ letterSpacing: 3 }}>
            Análisis clínico
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            Química sanguínea
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Mantén visibles los parámetros metabólicos y renales básicos para
            decisiones rápidas dentro del expediente.
          </Typography>
          <Stack direction="row" spacing={1}>
            {["Metabolismo", "Riesgo", "Control"].map((tag) => (
              <Chip key={tag} label={tag} size="small" variant="outlined" />
            ))}
          </Stack>
        </Stack>

        <Divider />

        <Stack spacing={3}>
          <ModernTextField
            label="Fecha del estudio"
            name="fechaQuimicaSanguinea"
            type="date"
            value={formValues.fechaQuimicaSanguinea || ""}
            onChange={handleInputChange}
            fullWidth
            inputProps={{ max: today }}
            InputLabelProps={{ shrink: true }}
            helperText="Registra la fecha más reciente del panel químico"
            sx={{ width: DATE_FIELD_WIDTH }}
          />

          {CHEMISTRY_FIELDS.map((field) => (
            <Stack key={field.name} spacing={1.5}>
              <Typography variant="subtitle2" color="text.secondary">
                {field.label}
              </Typography>
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                sx={{ flexWrap: "wrap" }}
              >
                <ModernTextField
                  label="Valor"
                  name={field.name}
                  type="number"
                  value={formValues[field.name] || ""}
                  onChange={handleInputChange}
                  fullWidth
                  sx={{ width: VALUE_FIELD_WIDTH }}
                />
                <ModernTextField
                  select
                  label="Unidad"
                  name={`${field.name}Medida`}
                  value={formValues[`${field.name}Medida`] || field.units[0]}
                  onChange={handleInputChange}
                  fullWidth
                  sx={{ width: UNIT_FIELD_WIDTH }}
                >
                  {field.units.map((unit) => (
                    <MenuItem key={unit} value={unit}>
                      {unit}
                    </MenuItem>
                  ))}
                </ModernTextField>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </GlassPanel>
  );
};

export default QuimicaSanguinea;
